/** Add System "Category" — drives which Type options are shown (chained dropdowns). */
export type SystemCategory = 'HVAC' | 'Water Heater' | 'Electrical' | 'Other';

export const SYSTEM_CATEGORIES: SystemCategory[] = ['HVAC', 'Water Heater', 'Electrical', 'Other'];

/**
 * Matches ServiceItemForm BasicInfoSection "Type" (systemReadingsTypeId).
 * `value` is the system_readings_type row id — must stay in lockstep with kalos-core
 * migration 287 (ids 1–10 existing, 12–20 new). Order within HVAC follows the spec.
 */
export const SYSTEM_READINGS_TYPE_OPTIONS = [
  // HVAC
  { label: 'Straight-cool AC w/ heatstrips', value: 1, category: 'HVAC' },
  { label: 'Heat-pump AC', value: 2, category: 'HVAC' },
  { label: 'Ductless Mini-Split', value: 12, category: 'HVAC' },
  { label: 'Furnace (Straight-Cool)', value: 3, category: 'HVAC' },
  { label: 'Furnace (Heat-pump)', value: 6, category: 'HVAC' },
  { label: 'AC w/ Reheat', value: 9, category: 'HVAC' },
  { label: 'Pool Heater - Gas', value: 4, category: 'HVAC' },
  { label: 'Pool Heater - Heat Pump', value: 5, category: 'HVAC' },
  { label: 'Cooler', value: 7, category: 'HVAC' },
  { label: 'Freezer', value: 8, category: 'HVAC' },
  // Water Heater
  { label: 'Tanked Water Heater', value: 13, category: 'Water Heater' },
  { label: 'Tankless Water Heater', value: 14, category: 'Water Heater' },
  { label: 'Heat Pump Water Heater', value: 15, category: 'Water Heater' },
  // Electrical
  { label: 'Main Panel', value: 16, category: 'Electrical' },
  { label: 'Sub-Panel', value: 17, category: 'Electrical' },
  { label: 'Generator', value: 18, category: 'Electrical' },
  { label: 'EV Charger', value: 19, category: 'Electrical' },
  { label: 'Surge Protection Device', value: 20, category: 'Electrical' },
  // Other
  { label: 'Other', value: 10, category: 'Other' },
] as const satisfies ReadonlyArray<{ label: string; value: number; category: SystemCategory }>;

export function getSystemReadingsTypeLabel(systemReadingsTypeId: number): string {
  const match = SYSTEM_READINGS_TYPE_OPTIONS.find((o) => o.value === systemReadingsTypeId);
  return match?.label ?? '';
}

/** Returns the category a type id belongs to, or '' if the id is unknown. */
export function getCategoryForType(systemReadingsTypeId: number): SystemCategory | '' {
  const match = SYSTEM_READINGS_TYPE_OPTIONS.find((o) => o.value === systemReadingsTypeId);
  return match?.category ?? '';
}

/** Type options for a category — empty until a category is chosen (drives the chained Type dropdown). */
export function getTypesForCategory(
  category: SystemCategory | '',
): ReadonlyArray<{ label: string; value: number; category: SystemCategory }> {
  if (!category) return [];
  return SYSTEM_READINGS_TYPE_OPTIONS.filter((o) => o.category === category);
}
